import { cloudChiprApi } from "../../services/cloudchipr.api";

export const getUsersMeSelector = cloudChiprApi.endpoints.getUsersMe.select({});
